module.exports = __webpack_public_path__ + "static/media/VMBCH-CR-T0-A1-CF-CC-8613.4d1d2ba7.png";